var m = require('mithril');

module.exports = {
  view: function (vnode) {
    var attrs = vnode.attrs || {};
    var disabled = Boolean(attrs.disabled);

    var modalSwitchSize = {
      width: '4.4rem',
      height: '2.3rem',
    };
    var modalKnobConfig = {
      padding: '2px',
      knobHeight: 'calc(var(--switch-height) - 4px)',
      knobWidth: 'calc(var(--switch-height) * 1.2)',
    };
    var wrapperClass = 'switch';
    if (attrs.class) wrapperClass += ' ' + attrs.class;

    var sliderClass = 'slider';
    if (attrs.sliderClass) sliderClass += ' ' + attrs.sliderClass;

    var style = attrs.style ? Object.assign({}, attrs.style) : {};

    if (attrs.width) {
      style['--switch-width'] = attrs.width;
    } else if (attrs.size === 'modal') {
      style['--switch-width'] = modalSwitchSize.width;
      style['--switch-knob-width'] = modalKnobConfig.knobWidth;
    }

    if (attrs.height) {
      style['--switch-height'] = attrs.height;
    } else if (attrs.size === 'modal') {
      style['--switch-height'] = modalSwitchSize.height;
      style['--switch-padding'] = modalKnobConfig.padding;
      style['--switch-knob-height'] = modalKnobConfig.knobHeight;
    }
    if (attrs.offColor) style['--switch-off'] = attrs.offColor;

    if (attrs.onColor) style['--switch-on'] = attrs.onColor;
    if (attrs.focusColor) style['--switch-focus'] = attrs.focusColor;

    var inputAttrs = {
      type: 'checkbox',
      name: attrs.name,
      checked: Boolean(attrs.checked),
      disabled: disabled,
      onclick: attrs.onclick,
      onchange: attrs.onchange,
      oninput: attrs.oninput,
      'aria-label': attrs.ariaLabel || attrs.label || attrs.name || 'Toggle',
    };

    if (attrs.id) inputAttrs.id = attrs.id;
    if (attrs.tabindex != null) inputAttrs.tabindex = attrs.tabindex;

    return m('label', { class: wrapperClass, style: style }, [
      m('input', inputAttrs),
      m('span', { class: sliderClass }),
    ]);
  },
};
